import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-194">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-195">
          {/* Overlay */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-charcoal-900/60 backdrop-blur-sm" onClick={onClose} data-id="element-196" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-cream-50 rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden border border-cream-200" role="dialog" aria-modal="true" aria-label={title} data-id="element-197">
            {/* Header */}
            <div className="flex items-center justify-between px-8 py-5 border-b border-cream-200 flex-shrink-0" data-id="element-198">
              <h2 className="font-serif text-2xl text-teal-900" data-id="element-199">{title}</h2>
              <button onClick={onClose} className="text-charcoal-800 hover:text-teal-900 transition-colors p-1 rounded-lg hover:bg-cream-100" aria-label="Close" data-id="element-200">
                <X size={22} data-id="element-201" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="overflow-y-auto px-8 py-6 text-charcoal-800 leading-relaxed text-[15px] space-y-4" data-id="element-202">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}